import { Segmented } from "@/modules/reports/Segmented";
import { PRODUCT_VIEWS, type ProductsState } from "@/modules/reports/skuTrends";

/**
 * Reports > Products' two views, as a switch under the header (#678): the
 * all-time best sellers it opened with, and the SKU trends over a range.
 * Both are this one page, so the switch is in the page's address and a view
 * can be linked to.
 */
export function ProductViews({
  state,
  change,
}: {
  state: ProductsState;
  change: (patch: Partial<ProductsState>) => void;
}) {
  return (
    <Segmented
      label="Products view"
      value={state.view}
      options={PRODUCT_VIEWS}
      onChange={(view) => {
        change({ view });
      }}
    />
  );
}
